import { render, staticRenderFns } from "./architecture.vue?vue&type=template&id=33bd961c&scoped=true&"
import script from "./architecture.vue?vue&type=script&lang=js&"
export * from "./architecture.vue?vue&type=script&lang=js&"
import style0 from "./architecture.vue?vue&type=style&index=0&id=33bd961c&scoped=scoped&lang=scss&"
import style1 from "./architecture.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd961c",
  null
  
)

export default component.exports